import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { Deck } from "@apiserver-rest/ponder-data-client-base";
import { getDeckRoute } from "@ponder-features/user/decks/deck-router";
import { styleDeckElementBackgroundSmall } from "@ponder-features/user/decks/deck-utils";

@Component({
    selector: "magic-set-decks-row",
    imports: [],
    templateUrl: "./magic-set-decks-row.component.html"
})
export class MagicSetDecksRowComponent implements AfterViewInit {
    @Input({ required: true }) public deck!: Deck;

    @ViewChild("containerOuter") private containerOuterRef!: ElementRef<HTMLDivElement>;
    @ViewChild("containerInner") private containerInnerRef!: ElementRef<HTMLDivElement>;

    public deckUrl!: string;

    public constructor() {

    }

    public ngOnInit(): void {
        this.deckUrl = getDeckRoute("ponder", this.deck.id);
    }

    public ngAfterViewInit(): void {
        styleDeckElementBackgroundSmall(
            this.containerOuterRef.nativeElement, 
            this.containerInnerRef.nativeElement, 
            this.deck.color!, 
            this.deck.backgroundCardId);
    }
}